module.exports = "query PimProductsFlagsSelectQuery{flags{edges{node{value:rowId label:title}}}}"